<template>

    <setup_content v-if="active_step == 'profitable_step1_1'" title="Действительный валовой доход для объектов оценки (руб./год)">

        <template v-slot:buttons>
            <div class="d-flex justify-content-center mb-2" style="gap: .625rem;">
				<!--
                <b-button v-if="check_roles([ 'model' ])" variant="outline-primary-secondary" v-on:click="() => $emit('update_counts')">
                    <span>Проверка заполненности</span><base-icon name="refresh" size="md" />
				</b-button>
				-->

                <b-button v-if="!!(objects_count - data.objects_count)"
                    variant="outline-primary-secondary"
                    @click="() => $emit('set_active_step', 'profitable_step1_1_1')"
                >
                    <span>{{ not_editable ? "Настройки расчета" : "Настроить расчет" }}</span><base-icon name="settings" size="md" />
                </b-button>
            </div>
        </template>

        <statistic :total="objects_count" :stats="[['', data.objects_count]]" :warning="!!(objects_count - data.objects_count)">
            <template v-slot:warning>
                <div style="line-height: 1.5rem;">
                    У части объектов оценки характеристика не заполнена.<br>
                    <!-- Дозаполните недостающие значения и проведите проверку снова или <i>настройте расчет действительного валового дохода для объектов оценки</i> -->
                </div>
            </template>
        </statistic>

    </setup_content>

    <!-- Настройка расчета Действительного валового дохода -->

    <potential_gross_income v-else-if="active_step.startsWith('profitable_step1_1_1')"
		:id="id"
		:group_id="group_id"
        :objects_count="objects_count - data.objects_count" :data="data.potential_gross_income"
		v-on:set_value="(key, value) => set_value('potential_gross_income.' + key, value)"
        :active_step="active_step" v-on:set_active_step="(step_id) => $emit('set_active_step', step_id)"
		v-on:update_counts="() => $emit('update_counts')"
		v-on:need_refresh="() => $emit('need_refresh')"
        :not_editable="not_editable"
        :capitalization_data="capitalization_data"
    />

    <setup_content v-else-if="active_step == 'profitable_step1_1_2'" title="Потери от недозагрузки для объектов оценки (руб./год)">

        <template v-slot:buttons>
            <div v-if="check_roles([ 'model' ])" class="d-flex justify-content-center mb-2" style="gap: .625rem;">
                <b-button variant="outline-primary-secondary" v-on:click="() => $emit('update_counts')">
                    <span>Проверка заполненности</span><base-icon name="refresh" size="md" />
                </b-button>
            </div>
        </template>

        <statistic :total="objects_count - data.objects_count" :stats="[['', data.underload.objects_count]]"
            :warning="!!(objects_count - data.objects_count - data.underload.objects_count)"
        >
            <template v-slot:warning>
                <div style="line-height: 1.5rem;">
                    У части объектов оценки характеристика не заполнена.<br>
                    <!-- Дозаполните недостающие значения и проведите проверку снова или <i>настройте расчет потери от недозагрузки для объектов оценки</i> ниже -->
                </div>
            </template>
        </statistic>

        <setup_frame v-if="!!(objects_count - data.objects_count - data.underload.objects_count)"
            title="Настройка расчета потерь от недозагрузки для объектов оценки (руб./год)"
        >

        <div class="element-row mb-3">
                <label class="element-row_label"><span>Выберите способ определения коэффициента недозагрузки</span></label>
                <div class="element-row_fields">
                    <b-form-radio-group
                        :options="['Рассчитать', 'Данные Пользователя']"
                        v-model="data.underload.type"
                        @change="(value) => set_value('underload.type', value)"
                        :disabled="!check_roles([ 'model' ]) || not_editable"
                    />
                </div>
            </div>

            <div v-if="data.underload.type == 'Рассчитать'">
                <element_row
                    title="Доля свободных площадей" :data="data.underload.area_share"
                    :validation="fields['underload.area_share']" v-on:set_value="(key, value) => set_value(`underload.area_share.${key}`, value)"
                    :readonly="!check_roles([ 'model' ]) || not_editable"
                />

                <div class="element-row">
                    <label class="element-row_label"><span>Период недозагрузки</span></label>
                    <div class="element-row_fields">
                        <v-select class="element-row_field" :options="period_options"
                            :value="data.underload.period"
                            @input="(value) => set_value('underload.period', value)"
                            :disabled="!check_roles([ 'model' ]) || not_editable"
                            :clearable="false" required
                        />
                    </div>
                </div>

                <element_row
                    title="Количество периодов недозагрузки" :data="data.underload.period_count"
                    :validation="fields['underload.period_count']" v-on:set_value="(key, value) => set_value(`underload.period_count.${key}`, value)"
                    :readonly="!check_roles([ 'model' ]) || not_editable"
                />

                <element_row title="Коэффициент недозагрузки" :data="{ value : data.underload.coef }" readonly without_source not_required bold />
            </div>

            <div v-else-if="data.underload.type == 'Данные Пользователя'">
                <element_row
                    title="Коэффициент недозагрузки" :data="data.underload.custom_coef"
                    :validation="fields['underload.custom_coef']" v-on:set_value="(key, value) => set_value(`underload.custom_coef.${key}`, value)"
                    :readonly="!check_roles([ 'model' ]) || not_editable"
                />
            </div>
            
        </setup_frame>

    </setup_content>

    <setup_content v-else-if="active_step == 'profitable_step1_1_3'" title="Потери при сборе арендной платы для объектов оценки (руб./год)">

        <template v-slot:buttons>
            <div v-if="check_roles([ 'model' ])" class="d-flex justify-content-center mb-2" style="gap: .625rem;">
                <b-button variant="outline-primary-secondary" v-on:click="() => $emit('update_counts')">
                    <span>Проверка заполненности</span><base-icon name="refresh" size="md" />
                </b-button>
            </div>
        </template>

        <statistic :total="objects_count - data.objects_count" :stats="[['', data.rent_collection.objects_count]]"
            :warning="!!(objects_count - data.objects_count - data.rent_collection.objects_count)"
        >
            <template v-slot:warning>
                <div style="line-height: 1.5rem;">
                    У части объектов оценки характеристика не заполнена.<br>
                    <!-- Дозаполните недостающие значения и проведите проверку снова или <i>настройте расчет потерь при сборе арендной платы для объектов оценки</i> ниже -->
                </div>
            </template>
        </statistic>

        <setup_frame v-if="!!(objects_count - data.objects_count - data.rent_collection.objects_count)" title="Настройка расчета потерь при сборе арендной платы">
            
            <element_row
                title="Коэффициент потерь при сборе арендной платы" :data="data.rent_collection.coef"
                :validation="fields['rent_collection.coef']" v-on:set_value="(key, value) => set_value(`rent_collection.coef.${key}`, value)"
                :readonly="!check_roles([ 'model' ]) || not_editable"
            />

        </setup_frame>

    </setup_content>
</template>

<script>
import setup_content from "../../setup_assets/content"
import setup_frame from "../../setup_assets/frame"
import statistic from "../../setup_assets/statistic"
import potential_gross_income from "./potential_gross_income"
import api from "../../../../../../api"
import element_row from "../../../../../widgets/element-row"
import variables from "../../../../../../api/variables"

export default
{
	props :
	{
		id : String,
		data : Object,
        capitalization_data : Object,
		group_id : String,
        objects_count : Number,
        active_step : String,
		not_editable : Boolean
	},

	components :
	{
        setup_content,
        setup_frame,
		statistic,
        potential_gross_income,
        element_row
	},

	data()
	{
		return {
            period_options : Object.values(variables.periods.types).map(({ simple }) => simple),
            fields: {
                "underload.area_share":
                {
                    check: (value) => api.check_number({ value : value, gt : 0, lte : 1 }),
                    msg: "От 0 (не включительно) до 1",
                    gt_min: 0
                },
                "underload.period_count":
                {
                    check: (value) => this.check_period_count(value),
                    msg: null
                },
                "underload.custom_coef":
                {
                    check: (value) => api.check_number({ value : value, gte : 0, lte : 1 }),
                    msg: "От 0 до 1"
                },
                "rent_collection.coef":
                {
                    check: (value) => api.check_number({ value : value, gte : 0, lte : 1 }),
                    msg: "От 0 до 1"
                }
            }
		}
	},

    watch :
    {
        data :
        {
            handler(newData)
            {
                this.fields["underload.period_count"].msg = newData.underload.period === "Год" ? "Равно 1"
                    : `Целое число от 0 (не включительно) до ${variables.periods.getBySimple(newData.underload.period).max}`
            },
            immediate: true
        }
    },

	methods :
	{
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

        check_period_count(value)
        {
            return (
                    this.data.underload.period !== "Год"
                    && api.check_number({ value, accuracy : 0, gt : 0, lte : variables.periods.getBySimple(this.data.underload.period).max })
                )
                || (
                    this.data.underload.period === "Год"
                    && api.check_number({ value, accuracy : 0, gte : 1, lte : variables.periods.getBySimple(this.data.underload.period).max })
                )
        },

        set_value(field, value)
        {
            this.$emit("set_value", field, value)

            
            if (field == "underload.period")
            {
                const max = variables.periods.getBySimple(value).max

                if (this.data.underload.period_count.value > max) {
                    this.$emit("set_value", "underload.period_count.value", max)
                }
            }
        }
	}
}

</script>
